export const eventOn = (event, callback) =>
	document.addEventListener(event, callback)

export const eventDispatch = (event, data) =>
	document.dispatchEvent(new CustomEvent(event, { detail: data }))

export const eventOff = (event, callback) =>
	document.removeEventListener(event, callback)